<!--
 * @Description: 
 * @Author: pliybird
 * @Date: 2023-05-30 16:21:14
 * @LastEditTime: 2023-08-03 16:31:29
 * @LastEditors: 陈绍斌 1748362428@qq.com
 * @filePath: Do not edit
-->
<template>
  <Layout >
    <PageHead :pageHeadData="PageHeadData"/>
    <ProductOverview :summarizeTextList="summarizeTextList" :videoData="videoData" />
    
    <!-- 业务蓝图 -->
    <section 
      class="rn-section-gap slider-bg-image" 
      :style="{ 'background-image': `url(${require('@/assets/images/ProductService/common/business-blueprint.png')})` }">
      <SectionTitle :title="$t('product.business_blueprint')" description="BUSINESS BLUEPRINT" textAlign="center" />
      <div class="container">
        <LoyaltyBlueprint />
      </div>
    </section>
    
    <ProductAbility :abilityData=AbilityData abilityType="loyalty" />
    <ProductSuperiority :productSuperiorityData="ProductSuperiorityData" />
    <!-- 典型案例 -->
    <ClassicCases :classicCasesData="ClassicCasesData" />
  </Layout>
</template>

<script>
    import Layout from '../../components/common/Layout'
    import Icon from '../../components/icon/Icon'
    import Separator from '../../components/elements/separator/Separator'
    import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
    import ProductOverview from './components/ProductOverview.vue'
    import ProductAbility from './components/ProductAbility.vue'
    import PageHead from './components/PageHead.vue'
    import ProductSuperiority from './components/ProductSuperiority/ProductSuperiority.vue'
    import ClassicCases from '../IndustrySolution/components/ClassicCases.vue'
    import LoyaltyBlueprint from './components/BusinessBlueprint/LoyaltyBlueprint.vue'
    
    import { 
        Loyalty_icon01,
        Loyalty_icon02,
        Loyalty_icon03,
        Loyalty_icon04,
        numImage01,
        numImage02,
        numImage03,
        numImage04,
        numImage05,
        zhongtongBackground,
        HITACHIBackground,
        YTOBackground,
        ADORITZIcon,
        AMERSPORTSIcon,
        ARCTERYXIcon,
        CHICMAXIcon,
        DWIcon,
        gfIcon,
        HERBORISTIcon,
        JahwaIcon,
        LAOPUIcon,
        LeysenIcon,
        lovebabyIcon,
        MAOGEPINGIcon,
        MOCoIcon,
        SALOMONIcon,
        SUUNTOIcon,
        ThomasCookIcon,
        unknowIcon,
        WiIcon,
        LoyaltyAbility01,
        LoyaltyAbility02,
        LoyaltyAbility03,
        LoyaltyAbility04,
        LoyaltyAbility05,
      } from './Image.js'

    export default {
        name: 'VyungLoyalty',
        components: {
          Icon, Layout, Separator, SectionTitle,  
          ProductOverview, ProductAbility, PageHead,ProductSuperiority,ClassicCases,LoyaltyBlueprint
        },
        data() {
            return {
                //页面头部
                PageHeadData:{
                  engTitle:'Loyalty',
                  text: this.$t('product.VyungLoyalty.head.text'),
                  subtitle: this.$t('product.VyungLoyalty.head.subtitle'),
                  image:require('@/assets/images/ProductService/VyungLoyalty/Loyalty-Image.png'),
                },
                //产品概述
                videoData:[{
                    src:process.env.VUE_APP_VIDEO_URL+'/$web/video/loyalty.mp4?'+process.env.VUE_APP_VIDEO_RAXWDL,
                    // src:'https://vyunghome.blob.core.chinacloudapi.cn/$web/video/loyalty.mp4?sp=racwdl&st=2023-05-23T06:12:11Z&se=2023-06-23T14:12:11Z&spr=https&sv=2022-11-02&sr=c&sig=ajt5HDJh%2BGE7TJ%2Bdo8uNSAqOUJzZWan37uhgbk%2B7bRI%3D',
                    thumb: require(`@/assets/images/ProductService/VyungLoyalty/loyalty_tumb.png`)
                }],
                summarizeTextList: {
                  text01:this.$t('product.VyungLoyalty.product_overview.text01'),
                  text02:this.$t('product.VyungLoyalty.product_overview.text02')
                },
                //业务蓝图
                // LoyaltyBlueprintImage,
                //产品功能
                AbilityData:[
                  {
                    title: this.$t('product.VyungLoyalty.product_ability.card01.title'),
                    text: this.$t('product.VyungLoyalty.product_ability.card01.text'),
                    contentImage:LoyaltyAbility01,
                    numImage:numImage01,
                  },
                  {
                    title: this.$t('product.VyungLoyalty.product_ability.card02.title'),
                    text: this.$t('product.VyungLoyalty.product_ability.card02.text'),
                    contentImage:LoyaltyAbility02,
                    numImage:numImage02,
                  },
                  {
                    title: this.$t('product.VyungLoyalty.product_ability.card03.title'),
                    text: this.$t('product.VyungLoyalty.product_ability.card03.text'),
                    contentImage:LoyaltyAbility03,
                    numImage:numImage03,
                  },
                  {
                    title: this.$t('product.VyungLoyalty.product_ability.card04.title'),
                    text: this.$t('product.VyungLoyalty.product_ability.card04.text'),
                    contentImage:LoyaltyAbility04,
                    numImage:numImage04,
                  },
                  {
                    title: this.$t('product.VyungLoyalty.product_ability.card05.title'),
                    text: this.$t('product.VyungLoyalty.product_ability.card05.text'),
                    contentImage:LoyaltyAbility05,
                    numImage:numImage05,
                  },
                ],

                //产品优势
                ProductSuperiorityData:[
                  {
                    title: this.$t('product.VyungLoyalty.product_advantages.card01.title'),
                    text: this.$t('product.VyungLoyalty.product_advantages.card01.text'),
                    contentImage:Loyalty_icon01,
                  },
                  {
                    title: this.$t('product.VyungLoyalty.product_advantages.card02.title'),
                    text: this.$t('product.VyungLoyalty.product_advantages.card02.text'),
                    contentImage:Loyalty_icon02,
                  },
                  {
                    title: this.$t('product.VyungLoyalty.product_advantages.card03.title'),
                    text: this.$t('product.VyungLoyalty.product_advantages.card03.text'),
                    contentImage:Loyalty_icon03,
                  },             
                  {
                    title: this.$t('product.VyungLoyalty.product_advantages.card04.title'),
                    text: this.$t('product.VyungLoyalty.product_advantages.card04.text'),
                    contentImage:Loyalty_icon04,
                  }
                ],

                //产品案例
                ClassicCasesData:[
                  {
                    brandIcon: JahwaIcon,
                  },
                  {
                    brandIcon: HERBORISTIcon,
                  },
                  {
                    brandIcon: gfIcon,
                  },
                  // {
                  //   brandIcon: AMERSPORTSIcon,
                  // },
                  // {
                  //   brandIcon: ARCTERYXIcon,
                  // },
                  // {
                  //   brandIcon: SALOMONIcon,
                  // },
                  // {
                  //   brandIcon: SUUNTOIcon,
                  // },
                  {
                    brandIcon: unknowIcon,
                  },
                  {
                    brandIcon: CHICMAXIcon,
                  },
                  {
                    // imageBackground: HITACHIBackground,
                    brandIcon: ADORITZIcon,
                  },
                  {
                    brandIcon: MOCoIcon,
                  },
                  {
                    brandIcon: DWIcon,
                  },
                  {
                    brandIcon: LeysenIcon,
                  },
                  {
                    brandIcon: lovebabyIcon,
                  },
                  {
                    brandIcon: MAOGEPINGIcon,
                  },
                  {
                    brandIcon: WiIcon,
                  },
                  {
                    brandIcon: ThomasCookIcon,
                  },
                  {
                    brandIcon: LAOPUIcon,
                  }
                ]
              }
        },
        methods:{
        
        }
    }
</script>